import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import AdvertisementService from '../../service/AdvertisementService';
import CustomerAdCard from '../../component/advertisement/CustomerAdCard';

function ListingPage() {
    const { user, isLoggedIn} = useContext(AuthContext);
    const navigate = useNavigate();

    const [listing, setListing] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate('/login');
            return;
        }

        const fetchListing = async () => {
            setLoading(true);
            try {
                if (user?.token) {
                    const response = await AdvertisementService.getCustomerAdvertisements(user.token);
                    setListing(response || []);
                }
            } catch (error) {
                console.error('Failed to fetch listings:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchListing();
    }, [isLoggedIn, navigate, user]);

    return (
        <section className='global-padding lead_page min-h-400'>
        <div className="container">
             <div className="row justify-content-center">
                <div className='col-md-11 lead_title'>
                <h3 className="text-left mb-3 mb-md-3">My Listings</h3>
                </div>
             </div>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="text-muted">Loading listings...</p>
                    </div>
                </div>
            ) : listing.length > 0 ? (
                <div className="row fade-in gx-0 justify-content-center">
                    {listing.map(ad => (
                        <CustomerAdCard
                            key={ad.id}
                            advertisement={ad}
                        />
                    ))}
                </div>
            ) : (
                <div className="col-md-11 adv_found_err mt-md-0 mt-3 py-md-3 text-center">
                    <h5 className="mb-0">No advertisements found.</h5>
                </div>
            )}
        </div>
        </section>
    );
}

export default ListingPage;
